module.exports = __webpack_public_path__ + "static/img/icon_bg1_en.c5e16ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bg1_en.png
// module id = 5j9T
// module chunks = 0